export default {
  primary: '#ED6D35',
  primaryLight: '#ffa4a2',
  primaryDark: '#9a0007',
  secondary: '#9e9e9e',
  secondaryLight: '#cfcfcf',
  secondaryDark: '#707070',
  white: '#ffffff',
  black: '#000000',
  twitterBootstrap: {
    primary: '#017BFF',
    secondary: '#7F878E',
    success: '#29A745',
    danger: '#DC3645',
    warning: '#FFC20E',
    info: '#17A2B8'
  },
  custom: {}
}
